import { Box, Flex, Heading, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import { Disclosure } from '@common/elements/Disclosure';
import { FontFamily } from '@common/theming/Fonts';
import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type UIProps = {
  prevPage?: string | (() => void);
  nextPage?: string | (() => void);
};

export const UI: React.FC<PropsWithChildren<UIProps>> = ({ prevPage, nextPage, children }) => {
  const navigate = useNavigate();

  const handlePrevPage = () => {
    if (typeof prevPage === 'string') return navigate(prevPage);
    if (typeof prevPage === 'function') return prevPage();
  };

  const handleNextPage = () => {
    if (typeof nextPage === 'string') return navigate(nextPage);
    if (typeof nextPage === 'function') return nextPage();
  };

  return (
    <Flex bg="white" direction="column" h="100%" w="full" justifyContent={'space-between'}>
      {/* Navigation */}
      <Flex bg="white" justify={'center'} borderBottomWidth={1} borderBottomColor={'gray.50'}>
        <Flex
          maxW={920}
          mx={[5, 20]}
          width="full"
          direction="row"
          height={[70, 90]}
          color="white"
          alignItems={'center'}
          justifyContent="space-between">
          <Flex alignItems="flex-start">
            <Box as="button" onClick={handlePrevPage} w="30px">
              {prevPage && <Icon color="black" boxSize={['20px', '25px']} icon="arrow-left-long" />}
            </Box>
          </Flex>
          <Flex>
            <Image image="logo-black" w={[100, 150]} />
          </Flex>
          <Flex alignItems="flex-start">
            <Box as="button" onClick={handleNextPage} w="30px">
              {nextPage && <Icon color="black" boxSize={['20px', '25px']} icon="arrow-right-long" />}
            </Box>
          </Flex>
        </Flex>
      </Flex>

      {/* Body */}
      <Flex justifyContent="flex-start" direction={'column'} gap={5} py={['30px', '100px']} px={'30px'} height="100%">
        {/* Content */}
        <VStack marginX={'auto'} maxWidth={920} width="full" gap="20px">
          <Flex direction="column" justifyContent="space-betweeen" width="full" minH={100}>
            {children}
          </Flex>
          <Flex flex={['auto', 2]} justify={['end', 'start']} textAlign={['right', 'left']} direction="row" gap={2}>
            <Icon boxSize={3} color="gray.300" icon="lock"></Icon>
            <TextBlock color="gray.400" fontSize={'12px'}>
              Your info is secure and will never be shared
            </TextBlock>
          </Flex>
        </VStack>
      </Flex>

      {/* Footer */}
      <Flex
        backgroundColor="#263243"
        paddingX={5}
        direction={['column', 'row']}
        w="full"
        gap={1}
        align={['center', 'start']}>
        <VStack flex={['auto', 1]} px={['10px', '50px']} py="50px" color="white" fontSize={'0.8em'}>
          <Heading
            as="h3"
            fontSize="21px"
            color="white"
            fontWeight={'normal'}
            mb="20px"
            fontFamily={FontFamily.HELVETICA_NOW_REGULAR}>
            Important Disclosures
          </Heading>
          <Disclosure />
        </VStack>
      </Flex>
    </Flex>
  );
};
